(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["countdown-timer"] && !Shopify.designMode) return;
  try {
    class CountdownTimer extends HTMLElement {
    connectedCallback() {
      this.endDate = this.getAttribute('data-end-date');
      this.expiredMessage = this.getAttribute('data-expired-message') || 'Ended';

      if (!this.endDate) return;

      this.target = new Date(this.endDate).getTime();
      this.daysEl = this.querySelector('[data-timer="days"]');
      this.hoursEl = this.querySelector('[data-timer="hours"]');
      this.minutesEl = this.querySelector('[data-timer="minutes"]');
      this.secondsEl = this.querySelector('[data-timer="seconds"]');
      this.expiredEl = this.querySelector('.bc-countdown__expired');

      this.tick();
    }

    disconnectedCallback() {
      if (this.frameId) cancelAnimationFrame(this.frameId);
      if (this.timeoutId) clearTimeout(this.timeoutId);
    }

    pad(n) {
      return n < 10 ? '0' + n : String(n);
    }

    tick() {
      var now = Date.now();
      var diff = this.target - now;

      if (diff <= 0) {
        this.showExpired();
        return;
      }

      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);

      if (this.daysEl) this.daysEl.textContent = this.pad(d);
      if (this.hoursEl) this.hoursEl.textContent = this.pad(h);
      if (this.minutesEl) this.minutesEl.textContent = this.pad(m);
      if (this.secondsEl) this.secondsEl.textContent = this.pad(s);

      var self = this;
      this.frameId = requestAnimationFrame(function() {
        self.timeoutId = setTimeout(function() {
          self.tick();
        }, 1000 - (Date.now() % 1000));
      });
    }

    showExpired() {
      var units = this.querySelectorAll('.bc-countdown__unit, .bc-countdown__segment, .bc-countdown__sep');
      units.forEach(function(el) { el.hidden = true; });

      if (this.expiredEl) {
        this.expiredEl.hidden = false;
        this.expiredEl.textContent = this.expiredMessage;
      }
    }
  }

  if (!customElements.get('countdown-timer')) {
    customElements.define('countdown-timer', CountdownTimer);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-social-proof"] && !Shopify.designMode) return;
  try {
    class BcSocialProof extends HTMLElement {
    connectedCallback() {
      this.vEl = this.querySelector('[data-count="viewers"]');
      this.bEl = this.querySelector('[data-count="bought"]');
      this.pid = this.getAttribute('data-product-id') || '0';

      this.vMin = parseInt(this.getAttribute('data-viewers-min'), 10) || 1;
      this.vMax = parseInt(this.getAttribute('data-viewers-max'), 10) || this.vMin;
      this.bMin = parseInt(this.getAttribute('data-bought-min'), 10) || 1;
      this.bMax = parseInt(this.getAttribute('data-bought-max'), 10) || this.bMin;

      this.state = this.loadState();
      this.render(false);
      this.scheduleTick();
    }

    disconnectedCallback() {
      if (this.timer) clearTimeout(this.timer);
    }

    rand(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    clamp(value, min, max) {
      return Math.min(Math.max(value, min), max);
    }

    storageKey() {
      return 'bc-social-proof:' + this.pid;
    }

    loadState() {
      var fresh = {
        v: this.rand(this.vMin, this.vMax),
        b: this.rand(this.bMin, this.bMax),
        t: Date.now()
      };
      try {
        var stored = JSON.parse(sessionStorage.getItem(this.storageKey()));
        /* Reuse counts for 30 min so they stay stable across page loads */
        if (stored && stored.t > Date.now() - 30 * 60 * 1000) {
          return {
            v: this.clamp(stored.v, this.vMin, this.vMax),
            b: this.clamp(stored.b, this.bMin, this.bMax),
            t: stored.t
          };
        }
      } catch (e) {}
      this.saveState(fresh);
      return fresh;
    }

    saveState(state) {
      try {
        sessionStorage.setItem(this.storageKey(), JSON.stringify(state));
      } catch (e) {}
    }

    scheduleTick() {
      var self = this;
      /* New count every ~18–40s so it feels live without jittering */
      this.timer = setTimeout(function () {
        self.tick();
        self.scheduleTick();
      }, 18000 + Math.random() * 22000);
    }

    tick() {
      /* Viewers drift up/down; bought only climbs within a session */
      this.state.v = this.clamp(this.state.v + this.rand(-4, 6), this.vMin, this.vMax);
      if (Math.random() < 0.35 && this.state.b < this.bMax) {
        this.state.b += this.rand(0, 1);
      }
      this.state.t = Date.now();
      this.saveState(this.state);
      this.render(true);
    }

    render(animate) {
      if (this.vEl) {
        this.vEl.textContent = this.state.v.toLocaleString();
        if (animate) {
          this.vEl.classList.remove('is-ticking');
          void this.vEl.offsetWidth;
          this.vEl.classList.add('is-ticking');
        }
      }
      if (this.bEl) {
        this.bEl.textContent = this.state.b.toLocaleString();
      }
    }
  }

  if (!customElements.get('bc-social-proof')) {
    customElements.define('bc-social-proof', BcSocialProof);
  }
  } catch(e) { console.error(e); }
})();

})();
